import { Interval } from './animation'
import Easing from './easing'
import { clamp, lerp } from './math'

export function isArrayEqual(left, right) {
	if (left.length != right.length) {
		return false
	}
	else {
		for (let a = 0; a < left.length; a++) {
			if (left[a] !== right[a]) {
				return false
			}
		}
	}
	return true
}

export function offsetOfElement(element, top = document.body) {
	let node = element
	let { offsetLeft, offsetTop } = node
	while ((node = node.parentNode) && 'offsetLeft' in node && node != top) {
		offsetLeft += node.offsetLeft
		offsetTop += node.offsetTop
	}
	return { offsetLeft, offsetTop }
}

export const scrollTo = function () {
	const start = { x: 0, y: 0 }
	const end = { ...start }

	let curve = Easing.Linear
	let callback = null

	const interval = new Interval({
		autostart: false
	}, (pos) => {
		const ease = Easing.calc(pos, Easing.InOut, curve)
		const x = lerp(start.x, end.x, ease)
		const y = lerp(start.y, end.y, ease)
		window.scrollTo(x, y)

		if (pos == 1) {
			callback?.()
		}
	})

	// Stop when the user is potentially manually scrolling.
	addEventListener('mousewheel', () => interval.stop())
	addEventListener('keydown', () => interval.stop())

	return function (x = 0, y = 0, options = {}) {
		interval.duration = options.duration || 800
		curve = options.curve || Easing.Quint
		callback = options.callback

		interval.stop()
		start.x = window.scrollX || pageXOffset || document.body.scrollLeft
		start.y = window.scrollY || pageYOffset || document.body.scrollTop
		end.x = clamp(x, 0, document.body.scrollWidth - innerWidth)
		end.y = clamp(y, 0, document.body.scrollHeight - innerHeight)
		interval.start()
	}
}()	

export const scrollToElement = function (target, options = {}) {
	const offset = offsetOfElement(target)
	const offsetLeft = options.offsetLeft || 0
	const offsetTop = options.offsetTop || 0
	scrollTo(offset.offsetLeft + offsetLeft, offset.offsetTop + offsetTop, options)
}